import { map } from 'rxjs/operators';
import { Injectable, Inject } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { Company, AuthService } from '@ridango/core';
import { NgRedux } from '@angular-redux/store';
import { CompanyState } from './store/company.store';
import { CompanyActions } from './actions/company.actions';
import Env from '@ridango/core/env';

@Injectable({
    providedIn: 'root'
})
export class CompanyService {
    constructor(
        @Inject('ENV') private env: Env,
        private http: HttpClient,
        private ngRedux: NgRedux<CompanyState>,
        private actions: CompanyActions,
        private authService: AuthService
    ) {}

    getCustomerCompanies(token: string = null): Observable<Company[]> {
        const url = `${this.env.API_BASE_URL}/${this.env.REGION_ID}/company/customer`;
        return this.http.get(url).pipe(
            map((a: Company[]) => {
                a.map((c) => {
                    c.display = c.name;
                });
                return a;
            })
        );
    }

    fetchCompany(companyId, token: string = null): Observable<Company> {
        const url = `${this.env.API_BASE_URL}/${this.env.REGION_ID}/company/${companyId}`;
        return this.http.get(url).pipe(
            map((a: Company) => {
                return a;
            })
        );
    }

    setAllCompanies(companies: Company[]) {
        this.ngRedux.dispatch(this.actions.setAllCompanies(companies));
    }

    setSelectedCompany(company: Company) {
        if (company) {
            this.authService.setLoggedInUserName(company.name);
            this.authService.setLoggedInUserCompanyId(company.id);
        }

        this.ngRedux.dispatch(this.actions.setSelectedCompany(company));
    }

    saveCompanyProfile(payload, token: string = null): Observable<any> {
        const url = `${this.env.API_BASE_URL}/${this.env.REGION_ID}/company`;
        return this.http.put(url, payload);
    }

    saveDepartmentProfile(payload, companyId, token: string = null): Observable<any> {
        const url = `${this.env.API_GATEWAY_URL}/core/customer/v3/region/${this.env.REGION_ID}/company/${companyId}/department`;
        return this.http.post(url, payload);
    }
}
